// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectAll_root__8PHfc","icon":"SelectAll_icon__A_GeR","all":"SelectAll_all__DMfMg","mixed":"SelectAll_mixed__gHe3S"};